import { jsx as r } from "react/jsx-runtime";
import n from "react";
import { BoxState as x } from "./index.es524.js";
const a = n.createContext({
  boxState: new x()
}), s = (t) => {
  const { children: o, ...e } = t;
  return /* @__PURE__ */ r(a.Provider, { value: e, children: o });
};
export {
  a as BoxContext,
  s as BoxContextProvider
};
//# sourceMappingURL=index.es520.js.map
